import { createSlice } from '@reduxjs/toolkit'

export const ProjectInfoValidationSlice = createSlice({
  name: 'project_info_validation_slice',
  initialState: {
    value: {
    },
  }, reducers: {
    updateProjectInfoValidation: (state, action) => {
      if (action.payload.type) {
        return {
          ...state,
          value: {
            ...state.value, [action.payload.type]: action.payload.value
          }
        }
      }
      else {
        state.value = action.payload
      }
    }
  }

})
export const { updateProjectInfoValidation } = ProjectInfoValidationSlice.actions

export default ProjectInfoValidationSlice.reducer